<template>
    <div class="row">
      <div class="col-12">
        <loading-card v-if="isLoading" />
          <div v-else>
            <enrollments-table />
          </div>
      </div>
    </div>
</template>

<script>
import EnrollmentsTable from '../components/Tables/EnrollmentsTable.vue';
import Card from '../components/Cards/Card';
import LoadingCard from '../components/Cards/LoadingCard';
import config from '../constants/config';
import { mapGetters } from 'vuex';

export default {
  name: "Enrollments",
  components: {
    LoadingCard,
    Card,
    EnrollmentsTable,
  },
  data() {
    return {
      isLoading: false,
      perPage: config.DEFAULT_PER_PAGE
    };
  },
  async created() {
    this.isLoading = true;
    await this.fetchEnrollments();
    this.isLoading = false;
  },
  methods: {
    async fetchEnrollments() {
        await this.$store.dispatch('enrollment/fetchEnrollments',
            { skip: 0, limit: this.perPage });
    }
  },
  computed: {
    ...mapGetters('enrollment', ['optionalFields'])
  }
};
</script>
